import React from 'react';

const NotFound = () => {
  return (
    <div className='mx-10 mt-20 flex flex-col align-middle justify-center text-white'>
      <div className='flex flex-col justify-center items-center h-[400px]'>
        <h1 className='text-7xl font-bold font-sans'>404</h1>
        <h1 className='text-4xl font-bold font-sans mt-6'>Not Found</h1>
      </div>
    </div>
  );
};

export default NotFound;
